import { useMutation, useQueryClient } from '@tanstack/react-query';
import { payoutKeys } from './payout.keys';
import { withdrawUSDC } from './payout.service';
export const useWithdrawUSDC = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => withdrawUSDC(data),
        onSuccess: async () => {
            // Invalidate withdrawal history to refetch updated data
            await queryClient.invalidateQueries({
                queryKey: payoutKeys.withdrawalHistory(),
            });
        },
    });
};
